import React, { useEffect, useState } from "react";
import "../styles/snow-effect.css";

const SnowEffect = () => {
  const [snowflakes, setSnowflakes] = useState([]);

  useEffect(() => {
    // Create snowflakes with more variety
    const flakes = [];
    const flakeCount = 80; // Number of snowflakes

    const snowflakeSymbols = ["❄", "❅", "❆", "•"]; // Different snowflake styles

    for (let i = 0; i < flakeCount; i++) {
      flakes.push({
        id: i,
        left: Math.random() * 100, // Random horizontal position (0-100%)
        animationDuration: Math.random() * 4 + 6, // Random fall speed (8-14s) - slower
        animationDelay: Math.random() * 5, // Random start delay (0-5s)
        opacity: Math.random() * 0.6 + 0.4, // Random opacity (0.4-1)
        size: Math.random() * 12 + 6, // Random size (6-18px)
        symbol:
          snowflakeSymbols[Math.floor(Math.random() * snowflakeSymbols.length)],
        sway: Math.random() * 30 - 15, // Random horizontal sway (-15px to 15px)
      });
    }

    setSnowflakes(flakes);
  }, []);

  return (
    <div className="snow-container">
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className="snowflake"
          style={{
            left: `${flake.left}%`,
            animationDuration: `${flake.animationDuration}s`,
            animationDelay: `${flake.animationDelay}s`,
            opacity: flake.opacity,
            width: `${flake.size}px`,
            height: `${flake.size}px`,
            fontSize: `${flake.size}px`,
            "--sway": `${flake.sway}px`,
          }}
        >
          {flake.symbol}
        </div>
      ))}
    </div>
  );
};

export default SnowEffect;
